import { apiSlice } from "../../app/api/apiSlice"

export const rasApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        sendRepAffiliationSummaryEmail: builder.mutation({
            query: request => ({
                url: '/ras/request',
                method: 'POST',
                body: {
                    ...request
                }
            })
        })
    })
})

export const {
    useSendRepAffiliationSummaryEmailMutation
} = rasApiSlice